export default "__VITE_ASSET__BmtjBVRg__"